import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { ReturnStatement } from '@angular/compiler/src/output/output_ast';

@Directive({
  selector: '[AlphaOnly]'
})
export class AlphaOnlyDirective {

  @Input() OnlyAlpha: boolean;

  constructor(private readonly el: ElementRef) { }

  @HostListener('keypress', ['$event']) onKeyDown(event) {
      const e = <KeyboardEvent> event;
      const ch = e.key;
      const transformedInput = ch.replace(/[^A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]/g, '');

      if (transformedInput !== '') {
        return;
      } else {
        e.preventDefault();
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/directive/alpha-only.directive.ts